<script>
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import AnimatedLine from '../components/AnimatedLine.svelte'
  import Slider from '../components/Slider.svelte'

  let slideData = [
    {
      caption: '<strong class="accent">Comprehensive supply:</strong> Run CTV ads on major networks and publishers, including live TV.',
      mobileImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615930600/VerizonMediaATV/linear-lockscroll1-img1-mobile_irmu4g.jpg',
      desktopImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615930600/VerizonMediaATV/linear-lockscroll1-img1-desktop_zoyin6.jpg',
      altText: 'Family on couch watching videos on their devices'
    },
    {
      caption: '<strong class="accent">Rich insights:</strong> Leverage meaningful insights to hold your upfront partners more accountable, inform scatter buying, and better execute an omnichannel strategy.',
      mobileImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615930600/VerizonMediaATV/linear-lockscroll1-img2-mobile_tsjbps.jpg',
      desktopImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615930600/VerizonMediaATV/linear-lockscroll1-img2-desktop_fewfhz.jpg',
      altText: 'Mother and daughter using TV remote control'
    },
    {
      caption: '<strong class="accent">Better value:</strong> Proprietary measurement studies at no cost, dedicated service to extract the most meaningful insights and make your team comfortable, and compelling fee incentives.',
      mobileImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615930600/VerizonMediaATV/linear-lockscroll1-img3-mobile_kpliq8.jpg',
      desktopImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615930600/VerizonMediaATV/linear-lockscroll1-img3-desktop_hpgpwb.jpg',
      altText: 'Father and daughter using TV remote control'
    },
  ]


</script>
<section class="part4 no-max-width">
  <div class="content">
    <div class="rgrid-md-1-2">
      <div class="col">
        <AnimatedLine size={5} color="white" />
        <AnimatedTitle class="large" style="maskup">Activate your Upfront with Verizon Media DSP.</AnimatedTitle>
      </div>
    </div>
  </div>
  <div class="slider-wrap">
    <Slider slides={slideData} useFullWidth={true} />
  </div>
</section>

<style>
  .slider-wrap {
    margin-top: 70px;
  }
  section :global(.hline) {
    margin-bottom: 0.625rem;
  }
</style>